import Service from "../../AuthService";
const Material = {
    getMaterial(page) {
        return Service.get("/material?page="+page);
    },
    showMaterial(id) {
        return Service.get("/material/" + id);
    },
    updateMaterial(id, data) {
        return Service.put("/material/" + id, data);
    },
    createMaterial(data) {
        return Service.post("/material", data);
    },
    deleteMaterial(id,user_id) {
        return Service.delete("/material/" + id + "?userid="+user_id);
    },
    activeMaterial(id,user_id) {
        return Service.get("/material-active?id=" + id + "&userid="+user_id);
    },
    searchMaterial(page,data) {
        return Service.post("search-material?page="+page+"&code=" + data.code +"&type="+data.type+"&active="+data.active+"&type_bag="+data.type_bag_id);
    },
    getMaterialAll(){
        return Service.get("/material-get-all");
    },
    addMeterial(data){
        return Service.post("/add-material",data);
    },
    //วัสดุอุปกรณ์โรงงาน
    getFactorialMaterial(){
        return Service.get("/factorial-material");
    },
    createMaterialType(data){
        return Service.post("/create_material_type",data);
    },
    updateMaterialType(data){
        return Service.post("/update_material_type/"+data.id,data);
    },
    addPack(data){
        return Service.get("/add-pack-product?number="+data.pack);
    },
    deletePack(data){
        return Service.get("/delete-pack-product?number="+data.pack);
    },
};
export default Material;
